import { render, staticRenderFns } from "./LinksDropdown.vue?vue&type=template&id=3647121a"
import script from "./LinksDropdown.vue?vue&type=script&lang=js"
export * from "./LinksDropdown.vue?vue&type=script&lang=js"
import style0 from "./LinksDropdown.vue?vue&type=style&index=0&id=3647121a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports